import type { StatisticsTabResponse } from '../types';

export const STATISTICS_MOCK_DATA: StatisticsTabResponse = {
  overview: {
    type: 'table',
    home: {
      no: 17,
      leagueName: 'Premier League',
      playedMatches: 21,
      wins: 7,
      draws: 5,
      losses: 12,
      points: 30,
    },
    away: {
      no: 2,
      leagueName: 'Premier League',
      playedMatches: 21,
      wins: 14,
      draws: 5,
      losses: 2,
      points: 47,
    },
    groupTable: null,
    knockout: null,
  },
  previousMeetings: {
    homeWins: 2,
    draws: 0,
    awayWins: 8,
  },
  victoryProbability: {
    home: 13,
    draw: 11,
    away: 76,
  },
  lastFiveGames: {
    homeLastMatches: [
      {
        homeTeam: 'Nottingham Forest',
        awayTeam: 'Chelsea',
        homeScore: 3,
        awayScore: 2,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'W',
        homeGoalscorers: ['C. Hudson-Odoi', 'M. Gibbs-White', 'C. Wood'],
        awayGoalscorers: ['N. Jackson', 'C. Palmer'],
        date: '2026-03-15T15:00:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 23,
      },
      {
        homeTeam: 'Nottingham Forest',
        awayTeam: 'Brentford',
        homeScore: 2,
        awayScore: 2,
        homePenaltyScore: 5,
        awayPenaltyScore: 3,
        outcome: 'W',
        homeGoalscorers: ['C. Wood', 'R. Yates'],
        awayGoalscorers: ['B. Mbeumo', 'Y. Wissa'],
        date: '2026-03-08T17:30:00+00:00',
        league: 'FA Cup',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'quarter_final',
        stageNumber: null,
      },
      {
        homeTeam: 'Southampton',
        awayTeam: 'Nottingham Forest',
        homeScore: 0,
        awayScore: 1,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'W',
        homeGoalscorers: [],
        awayGoalscorers: ['C. Wood'],
        date: '2026-03-01T15:00:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 22,
      },
      {
        homeTeam: 'Liverpool',
        awayTeam: 'Nottingham Forest',
        homeScore: 2,
        awayScore: 0,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'L',
        homeGoalscorers: ['M. Salah', 'D. Jota'],
        awayGoalscorers: [],
        date: '2026-02-22T12:30:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 21,
      },
      {
        homeTeam: 'Nottingham Forest',
        awayTeam: 'Wolverhampton',
        homeScore: 0,
        awayScore: 0,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'D',
        homeGoalscorers: [],
        awayGoalscorers: [],
        date: '2026-02-15T15:00:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 20,
      },
    ],
    awayLastMatches: [
      {
        homeTeam: 'Manchester City',
        awayTeam: 'Arsenal',
        homeScore: 4,
        awayScore: 1,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'W',
        homeGoalscorers: ['E. Haaland', 'E. Haaland', 'P. Foden', 'K. De Bruyne'],
        awayGoalscorers: ['B. Saka'],
        date: '2026-03-15T17:30:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 23,
      },
      {
        homeTeam: 'Everton',
        awayTeam: 'Manchester City',
        homeScore: 1,
        awayScore: 3,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'W',
        homeGoalscorers: ['D. Calvert-Lewin'],
        awayGoalscorers: ['E. Haaland', 'J. Alvarez', 'P. Foden'],
        date: '2026-03-08T15:00:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 22,
      },
      {
        homeTeam: 'Manchester City',
        awayTeam: 'Liverpool',
        homeScore: 1,
        awayScore: 1,
        homePenaltyScore: 4,
        awayPenaltyScore: 2,
        outcome: 'W',
        homeGoalscorers: ['E. Haaland'],
        awayGoalscorers: ['M. Salah'],
        date: '2026-03-01T20:00:00+00:00',
        league: 'EFL Cup',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'final',
        stageNumber: null,
      },
      {
        homeTeam: 'Aston Villa',
        awayTeam: 'Manchester City',
        homeScore: 0,
        awayScore: 2,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'W',
        homeGoalscorers: [],
        awayGoalscorers: ['E. Haaland', 'B. Silva'],
        date: '2026-02-22T17:30:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 21,
      },
      {
        homeTeam: 'Manchester City',
        awayTeam: 'Tottenham',
        homeScore: 2,
        awayScore: 2,
        homePenaltyScore: null,
        awayPenaltyScore: null,
        outcome: 'D',
        homeGoalscorers: ['E. Haaland', 'K. De Bruyne'],
        awayGoalscorers: ['Son Heung-min', 'J. Maddison'],
        date: '2026-02-15T15:00:00+00:00',
        league: 'Premier League',
        leagueFlag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
        stage: 'matchweek',
        stageNumber: 20,
      },
    ],
  },
  topGoalscorers: {
    home: [
      {
        name: 'C. Wood',
        goals: 12,
        position: 'Striker',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/nz.svg',
      },
      {
        name: 'M. Gibbs-White',
        goals: 6,
        position: 'Midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
      },
      {
        name: 'A. Elanga',
        goals: 5,
        position: 'Winger',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/se.svg',
      },
      {
        name: 'T. Awoniyi',
        goals: 4,
        position: 'Striker',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ng.svg',
      },
    ],
    away: [
      {
        name: 'E. Haaland',
        goals: 19,
        position: 'Striker',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/no.svg',
      },
      {
        name: 'P. Foden',
        goals: 11,
        position: 'Midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/eng.svg',
      },
      {
        name: 'K. De Bruyne',
        goals: 8,
        position: 'Midfielder',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/be.svg',
      },
      {
        name: 'J. Alvarez',
        goals: 7,
        position: 'Forward',
        flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ar.svg',
      },
    ],
  },
  seasonStatistics: {
    prevYear: 2025,
    currentYear: 2026,
    leagueName: 'Premier League',
    home: {
      gamesPlayed: 20,
      winRate: 13,
      possession: 30,
      totalGoals: 20,
      goalsScored: 1,
      goalsConceded: 2,
      over15Goals: 12,
      over25Goals: 6,
      over05GoalsHT: 13,
      over15GoalsHT: 6,
      shotsPerGame: 34,
      shotsOnTarget: 11,
      shotsOffTarget: 11,
      shotsConcededOnTarget: 22,
      shotsConcededOffTarget: 22,
      yellowCards: 3,
      redCards: 2,
      freeKicks: 5,
      corners: 16,
      fouls: 20,
    },
    away: {
      gamesPlayed: 21,
      winRate: 77,
      possession: 83,
      totalGoals: 42,
      goalsScored: 3,
      goalsConceded: 1,
      over15Goals: 58,
      over25Goals: 27,
      over05GoalsHT: 38,
      over15GoalsHT: 12,
      shotsPerGame: 43,
      shotsOnTarget: 33,
      shotsOffTarget: 33,
      shotsConcededOnTarget: 44,
      shotsConcededOffTarget: 44,
      yellowCards: 5,
      redCards: 1,
      freeKicks: 11,
      corners: 12,
      fouls: 21,
    },
  },
  otherInfo: {
    venue: {
      name: 'City Ground, Nottingham',
      capacity: 30602,
    },
    referee: {
      name: 'Pierluigi Collina',
      flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/it.svg',
    },
  },
};
